import types from "../actions/actionTypes";
import initialState from "./initialState";

export default function organisationIdsNeedingUpdateReducer(state = initialState.organisationIdsNeedingUpdate, action) {

    const mergeIdIn = (organisationIds, id) => {
        return organisationIds.filter(o => o !== id)
            .concat(id);
    }

    const mergeIdsIn = (organisationIds, ids) => {     
        return organisationIds.filter(o => !ids.includes(o))
            .concat(ids);         
    }

    switch (action.type) {
        case types.LOAD_ORGANISATION_SUCCESS:
            return state.filter(s => s !== action.organisation.id);
        case types.UPDATED_ORGANISATION_INCOMING:
            return mergeIdIn(state, action.payload);
        case types.UPDATED_SITE_SUCCESS:
        case types.DELETED_SITE:
            return mergeIdIn(state, action.site.organisationId);
        case types.UPDATED_CONTACT_SUCCESS:
        case types.DELETED_CONTACT:               
            return mergeIdsIn(state, action.contact.organisationIds);     
        case types.UPDATED_SITE_INCOMING:
        case types.DELETED_SITE_INCOMING:       
            return mergeIdIn(state, action.payload.organisationId);
        case types.UPDATED_CONTACT_INCOMING:
        case types.DELETED_CONTACT_INCOMING:
            return mergeIdsIn(state, action.payload.organisationIds);
        default:
            return state;
    }
}